export const TRANSLATION = 'builder.job_tracking.edit_modal'
